import { httpV2 } from "../http";

const UserSettingsService = {
  get: () => httpV2.get("/user/settings"),
  set: (data) => httpV2.put("/user/settings", data),
};

export default UserSettingsService;
